import React, { useEffect, useState } from "react";
import Breadcrumbs from "common/Breadcrumbs/Breadcrumbs";
import { routeConstants } from "navigation/routeConstants";

import { ReactComponent as LeftArrowIcon } from "common/assets/icons/chevron-left.svg";
import FolderItem from "common/FolderItem/FolderItem";
import { useNavigate, useParams } from "react-router-dom";
import FileItem from "common/FileItem/FolderItem";
import { P } from "common/P/P";
import axios from "axios";
import { serviceConfig } from "configs";

const DocumentArchiveClosedIncomingDetailPage: React.FC = (): JSX.Element => {
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();

	const breadcrumbItems = [
		{ label: "Resminama arhiwi", path: routeConstants.root.route },
		{
			label: "Ýapylan daşky giren hatlar",
			path: routeConstants.documentArchiveClosedIncoming.route,
		},
		{ label: `${id}` },
	];
	const [letterDetails, setLetterDetails] = useState<any>(null);

	useEffect(() => {
		const fetchLetterDetails = async () => {
			try {
				const response = await axios.post(`${serviceConfig.apiUrl}/archieve`, {
					id: id,
					letterType: "DGH", // Assuming you know the letterType, adjust as necessary
				});
				setLetterDetails(response.data);
			} catch (error) {
				console.error("Error fetching letter details:", error);
			}
		};

		fetchLetterDetails();
	}, [id]);

	const handleBackClick = () => {
		navigate(-1);
	};

	const handleDownloadFile = (fileName: string) => {
		window.open(`${serviceConfig.apiUrl}/download?path=${fileName}`, "_blank");
	};

	return (
		<>
			<div className="grid grid-flow-row auto-rows-max pb-7 gap-6 px-6 pt-6 min-h-[90vh]">
				<Breadcrumbs items={breadcrumbItems} />
				<div
					className="p-[10px] rounded-md bg-lowOpacity w-max h-max cursor-pointer"
					onClick={handleBackClick}
				>
					<LeftArrowIcon className="stroke-mainColor" />
				</div>
				<div className="grid grid-cols-1 gap-6 p-6 shadow-md">
					<div className="grid gap-2 grid-cols-maxTwo place-items-center">
						<P size="p2" type="medium">
							Tarapyň görnüşi:
						</P>
						<P size="p2" type="regular">
							{letterDetails?.letterId.typeSide === "Personal"
								? "Şahsy tarap"
								: letterDetails?.letterId.typeSide === "Administrative"
								? "Edara görnüşli tarap"
								: ""}
						</P>
					</div>
					<div className="grid gap-2 grid-cols-maxTwo place-items-center">
						<P size="p2" type="medium">
							Hatyň görnüşi:
						</P>
						<P size="p2" type="regular">
							{letterDetails?.letterId.letterType}
						</P>
					</div>
					<div className="grid gap-2 grid-cols-maxTwo place-items-center">
						<P size="p2" type="medium">
							Kimden gelen:
						</P>
						<P size="p2" type="regular">
							{letterDetails?.letterId.fromWhere}
						</P>
					</div>
					<div className="grid gap-2 grid-cols-maxTwo place-items-center">
						<P size="p2" type="medium">
							Senesi:
						</P>
						<P size="p2" type="regular">
							{new Date(letterDetails?.letterId.receivedDate)
								.toLocaleDateString("en-GB", {
									timeZone: "UTC",
									day: "2-digit",
									month: "2-digit",
									year: "numeric",
								})
								.replace(/\//g, ".")}
						</P>
					</div>
					<div className="grid gap-2 grid-cols-maxFr ">
						<P size="p2" type="medium">
							Bellik:
						</P>
						<P size="p2" type="regular" className="break-words">
							{letterDetails?.letterId.note}
						</P>
					</div>
					<div className="grid grid-cols-1 gap-4">
						<P size="p2" type="medium">
							Berkidilen faýllar:
						</P>
						<div className="grid gap-6 lg:grid-cols-maxEight TwoXl:grid-cols-maxNine">
							{letterDetails?.letterId?.files.map((item: any, idx: number) => (
								<FileItem
									key={idx}
									name={item.name.split("_")[0]}
									size={item.size}
									type={item.type}
									notDeletable={true}
									onDownload={() => handleDownloadFile(item.path)}
								/>
							))}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default DocumentArchiveClosedIncomingDetailPage;
